import { AxiosResponse } from 'axios'
import { axiosClient } from '@App/api/api-client'
import Pathes from '@App/dicts/pathes'
import { PayeeRoyalties } from '@Entities/statements/payee-royalties'
import { Statement } from '@Entities/statements/statement'
import { LatestRoyaltiesDate } from '@Entities/statements/latest-royalties-date'
import { RateSheetUsagePeriod } from '@Entities/statements/rate-sheet-usage-period'
import { RateSheetDSP } from '@Entities/statements/rate-sheet-dsp'
import { RateSheetCollection } from '@Entities/statements/rate-sheet-collection'

export const getDspRates = (year: string, month: string, dsp?: string): Promise<AxiosResponse<RateSheetCollection[]>> =>
    axiosClient.get(Pathes.RightsHolder.dspRates(year, month, dsp))

export const getRatePeriods = (): Promise<AxiosResponse<RateSheetUsagePeriod[]>> =>
    axiosClient.get(Pathes.RightsHolder.ratePeriods())

export const getRateDsps = (): Promise<AxiosResponse<RateSheetDSP[]>> => axiosClient.get(Pathes.RightsHolder.rateDsps())

export const getRateSheetDownloadUrl = (
    rateSheetDownloadLink: string
): Promise<AxiosResponse<{ rateSheetURL: string }>> =>
    axiosClient.get(Pathes.RightsHolder.rateSheetDownload(rateSheetDownloadLink))

export const getLatestRoyaltiesDate = (rightsholderId: number): Promise<AxiosResponse<LatestRoyaltiesDate>> =>
    axiosClient.get(Pathes.RightsHolder.latestRoyalties(rightsholderId))

export const getStatements = (rightsholderId: number, payee: string): Promise<AxiosResponse<Statement[]>> =>
    axiosClient.get(Pathes.RightsHolder.statements(rightsholderId, payee))

export const getDistributionSummaryLink = (
    rightsholderIpId: number,
    year: string,
    month: string
): Promise<AxiosResponse<any>> =>
    axiosClient.get(Pathes.RightsHolder.distributionSummary(rightsholderIpId, year, month))

export const getRoyalties = (
    rightsholderId: number,
    year: string,
    month?: string,
    signal?: AbortSignal
): Promise<AxiosResponse<PayeeRoyalties[]>> =>
    axiosClient.get(Pathes.RightsHolder.royalties(rightsholderId, year, month), { signal: signal })

export const payeeActivityDownload = (pasLink: string) =>
    axiosClient.get(Pathes.RightsHolder.payeeActivityDownload(pasLink))

export const createTsvRequest = (rightsholderId: number, data: any): Promise<AxiosResponse> =>
    axiosClient.post(Pathes.RightsHolder.tsvRequest(rightsholderId), data)

export const createAnnualTsvRequest = (
    rightsholderId: number,
    data: { payee: string; year: string }
): Promise<AxiosResponse> => axiosClient.post(Pathes.RightsHolder.annualTSVRequest(rightsholderId), data)
